import Vue from 'vue';
import App from './App.vue';
import VueRouter from 'vue-router';
//import Home from './components/Pages/HomePage.vue'
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue';
import 'bootstrap/dist/css/bootstrap.css';
//import 'bootstrap-vue/src/icons.scss';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import VueSimpleAlert from 'vue-simple-alert';
import store from '@/services/Store';
import ChunkUploader from '@/components/ChunkUploader/ChunkUploader.vue';
import ScreenLoader from '@/components/ScreenLoader.vue';
import CookieLaw from 'vue-cookie-law';
import browserDetect from 'vue-browser-detect-plugin';
import AutocompleteCustom from './components/AutocompleteCustom.vue';
import Vuelidate from 'vuelidate';
import VueToastr from "vue-toastr";
import InlineSvg from 'vue-inline-svg';
import moment from 'moment';
import VueSimpleContextMenu from 'vue-simple-context-menu';
import { General } from '@/services/General';
import { i18n } from './i18n/i18n-setup';
import vSelect from 'vue-select'
import 'leaflet/dist/leaflet.css';
import 'vue-select/dist/vue-select.css';

//main.js
import VueSidebarMenu from 'vue-sidebar-menu'
import 'vue-sidebar-menu/dist/vue-sidebar-menu.css'


import 'vue-simple-context-menu/dist/vue-simple-context-menu.css';
require('./assets/css/custom.css');

import Axios from 'axios'
import VueAxios from 'vue-axios'

// c'è un bug relativo al typescript per cui il lazyloading non funziona correttamente, quindi al posto dell'import classico ho usato iun workaround
//const LazyLogin = () => import('@/components/Pages/LoginPage.vue');
//diventa
//const LazyLogin = resolve => (require as any)(['@/components/Pages/LoginPage.vue'], module => resolve(module.default));

const LazyHome = resolve => (require as any)(['@/components/Pages/HomePage.vue'], module => resolve(module.default));
const LazyProductsSearch = resolve => (require as any)(['@/components/Pages/ProductsSearchPage.vue'], module => resolve(module.default));
const LazyGaragesSearch = resolve => (require as any)(['@/components/Pages/GaragesSearchPage.vue'], module => resolve(module.default));
const LazyDocumentsSearch = resolve => (require as any)(['@/components/Pages/DocumentsSearchPage.vue'], module => resolve(module.default));
const LazyProductDocumentationPublic = resolve => (require as any)(['@/components/Pages/ProductDocumentationPublicPage.vue'], module => resolve(module.default));
const LazyLogin = resolve => (require as any)(['@/components/Pages/LoginPage.vue'], module => resolve(module.default));
const LazyDocumentsZipUploader = resolve => (require as any)(['@/components/Pages/DocumentsZipUploaderPage.vue'], module => resolve(module.default));
const LazyProductSpecsUploader = resolve => (require as any)(['@/components/Pages/ProductSpecsPage.vue'], module => resolve(module.default));
const LazyMaterialsSearch = resolve => (require as any)(['@/components/Pages/MaterialsSearchPage.vue'], module => resolve(module.default));
const LazyCqc = resolve => (require as any)(['@/components/Pages/CqcPage.vue'], module => resolve(module.default));
const LazyGroupsSearch = resolve => (require as any)(['@/components/Pages/GroupsSearchPage.vue'], module => resolve(module.default));
const LazyVehiclesSearch = resolve => (require as any)(['@/components/Pages/VehiclesSearchPage.vue'], module => resolve(module.default));
const LazyCommunications = resolve => (require as any)(['@/components/Pages/CommunicationsPage.vue'], module => resolve(module.default));
const LazyCommunicationsCategories = resolve => (require as any)(['@/components/Pages/CommunicationsCategoriesPage.vue'], module => resolve(module.default));
const LazyUserManagement = resolve => (require as any)(['@/components/Pages/UserManagement.vue'], module => resolve(module.default));
const LazyDocumentationDownload = resolve => (require as any)(['@/components/Pages/DocumentationDownloadPage.vue'], module => resolve(module.default));
const LazyNet20CustomersSearch = resolve => (require as any)(['@/components/Pages/Net20/CustomersSearchPage.vue'], module => resolve(module.default));
const LazyNet20WelcomeKitDeliveryInfoUploader = resolve => (require as any)(['@/components/Pages/Net20/WelcomeKitDeliveryInfoPage.vue'], module => resolve(module.default));
const LazyNet20ReportContractRenewals = resolve => (require as any)(['@/components/Pages/Net20/ReportContractRenewalsPage.vue'], module => resolve(module.default));
const LazyMateriaInfoUploader = resolve => (require as any)(['@/components/Pages/MaterialInfoPage.vue'], module => resolve(module.default));
const LazyNet20UsersMatrixManagement = resolve => (require as any)(['@/components/Pages/Net20/UsersMatrixManagementPage.vue'], module => resolve(module.default));
const LazyNet20Geolocator = resolve => (require as any)(['@/components/Pages/Net20/GeolocatorPage.vue'], module => resolve(module.default));
const LazyPpePlansSearch = resolve => (require as any)(['@/components/Pages/Ppe/PlansSearchPage.vue'], module => resolve(module.default));
const LazyPpeUsersMatrixManagement = resolve => (require as any)(['@/components/Pages/Ppe/PpeUsersMatrixManagementPage.vue'], module => resolve(module.default));
const LazyMerchandisingReport = resolve => (require as any)(['@/components/Pages/Ppe/MerchandisingReportPage.vue'], module => resolve(module.default));
const LazyCapitolatiSearch = resolve => (require as any)(['@/components/Pages/Pk/CapitolatiSearchPage.vue'], module => resolve(module.default));
const LazyContenitoreGraficheSearch = resolve => (require as any)(['@/components/Pages/Pk/ContenitoreGraficheSearchPage.vue'], module => resolve(module.default));
const LazyPesiImballiSearch = resolve => (require as any)(['@/components/Pages/Pk/PesiImballiSearchPage.vue'], module => resolve(module.default));
const LazyPallettizzazioniSearch = resolve => (require as any)(['@/components/Pages/Pk/PallettizzazioniSearchPage.vue'], module => resolve(module.default));
const LazyEmergencyPolicy = resolve => (require as any)(['@/components/Pages/EmergencyPolicyPage.vue'], module => resolve(module.default));
const LazyEmergencyContactManagement = resolve => (require as any)(['@/components/Pages/EmergencyContactPage.vue'], module => resolve(module.default));
const LazyLabelRepository = resolve => (require as any)(['@/components/Pages/MaterialLabel/LabelRepositoryPage.vue'], module => resolve(module.default));

let router = new VueRouter({
    mode: 'history',
    routes: [
        {
            path: '/products',
            name: 'Products',
            component: LazyProductsSearch,
            props: { mode: 2 },
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/products/:id',
            name: 'Productsid',
            component: LazyProductsSearch,
            props: { mode: 2 },
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/materials',
            name: 'Materials',
            component: LazyMaterialsSearch,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/document-search',
            name: 'DocumentSearch',
            component: LazyDocumentsSearch,
            meta:{
                plainLayout: true
            }
        },
        {
            path: '/product-documentation/:productCode',
            name: 'ProductDocumentationPublic',
            component: LazyProductDocumentationPublic,           
           
            meta:{
                plainLayout: true
            }
        },
        {
            path: '/',
            name: 'Home',
            component: LazyHome,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/communications-view/:id',
            name: 'CommunicationId',
            component: LazyHome,
            props: { mode: 2 },
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/document-upload',
            name: 'DocumentsUpload',
            component: LazyDocumentsZipUploader,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/product-specs-upload',
            name: 'ProductSpecsUpload',
            component: LazyProductSpecsUploader,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/material-info-upload',
            name: 'MaterialInfoUpload',
            component: LazyMateriaInfoUploader,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/cqc',
            name: 'cqc',
            component: LazyCqc,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/login',
            name: 'Login',
            component: LazyLogin
        },
        {
            path: '/groups',
            name: 'Groups',
            component: LazyGroupsSearch,
            meta: {
                requiresAuth: true
            },
        },
        {
            path: '/groups/:id',
            name: 'Groupsid',
            component: LazyGroupsSearch,
            props: { mode: 2 },
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/vehicles',
            name: 'Vehicles',
            component: LazyVehiclesSearch,
            meta: {
                requiresAuth: true
            },
        },
        {
            path: '/vehicles/:id',
            name: 'Vehiclesid',
            component: LazyVehiclesSearch,
            props: { mode: 2 },
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/communications',
            name: 'Communications',
            component: LazyCommunications,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/communications/:id',
            name: 'CommunicationsNumericId',
            component: LazyCommunications,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/usermanagement',
            name: 'UserManagement',
            component: LazyUserManagement,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/communicationsCategories',
            name: 'CommunicationsCategories',
            component: LazyCommunicationsCategories,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/communicationsCategories/:id',
            name: 'CommunicationCategoriesId',
            component: LazyCommunicationsCategories,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/document-download/',
            name: 'DocumentationDownload',
            component: LazyDocumentationDownload,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/signs',
            name: 'Sign',
            component: LazyGaragesSearch,
            props: { mode: 2 },
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/signs/:id',
            name: 'SignId',
            component: LazyGaragesSearch,
            props: { mode: 2 },
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/net20s',
            name: 'Customer',
            component: LazyNet20CustomersSearch,
            props: { mode: 2 },
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/net20s/:id',
            name: 'CustomerId',
            component: LazyNet20CustomersSearch,
            props: { mode: 2 },
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/welcome-kit-info',
            name: 'WelcomeKitDeliveryInfo',
            component: LazyNet20WelcomeKitDeliveryInfoUploader,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/report-contract-renewals',
            name: 'ReportContractRenewals',
            component: LazyNet20ReportContractRenewals,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/users-net20-management',
            name: 'UsersMatrixManagement',
            component: LazyNet20UsersMatrixManagement,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/geolocator',
            name: 'Geolocator',
            component: LazyNet20Geolocator,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/ppes',
            name: 'Plan',
            component: LazyPpePlansSearch,
            props: { mode: 2 },
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/ppes/:id',
            name: 'PlanId',
            component: LazyPpePlansSearch,
            props: { mode: 2 },
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/users-ppe-management',
            name: 'PpeUsersMatrixManagement',
            component: LazyPpeUsersMatrixManagement,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/merchandising-report',
            name: 'MerchandisingReport',
            component: LazyMerchandisingReport,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/capitolati-search',
            name: 'CapitolatiSearch',
            component: LazyCapitolatiSearch,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/contenitore-grafiche-search',
            name: 'ContenitoreGraficheSearch',
            component: LazyContenitoreGraficheSearch,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/pallettizzazioni-search',
            name: 'PallettizzazioniSearch',
            component: LazyPallettizzazioniSearch,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/pesi-imballi-search',
            name: 'PesiImballliSearch',
            component: LazyPesiImballiSearch,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/emergency-policy/:id',
            name: 'EmergencyPolicy',
            component: LazyEmergencyPolicy,
            meta: {
                plainLayout: true
            }
        },
        {
            path: '/emergency-contact-management',
            name: 'EmergencyContactManagement',
            component: LazyEmergencyContactManagement

        },
        {
            path: '/label-repository',
            name: 'LabelRepository',
            component: LazyLabelRepository,
             meta: {
                requiresAuth: true
            } 
        },
    ]
});
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
}

Vue.use(VueRouter);
Vue.use(BootstrapVue);
Vue.use(VueAxios, Axios);
Vue.use(VueSimpleAlert);
Vue.use(BootstrapVueIcons);
Vue.use(browserDetect);
Vue.use(Vuelidate);
Vue.use(VueToastr, {});
Vue.use(VueSidebarMenu)

Vue.component('chunk-uploader', ChunkUploader);
Vue.component('ScreenLoader', ScreenLoader);
Vue.component('CookieLaw', CookieLaw);
Vue.component('AutocompleteCustom', AutocompleteCustom);
Vue.component('inline-svg', InlineSvg);
Vue.component('vue-simple-context-menu', VueSimpleContextMenu);
Vue.component('v-select', vSelect)


Vue.filter('empty', (value: string) => {
    if (value == null || value == '') return '-';
    return value;
})

Vue.filter('truncate-base', (string: string, index: number) => {
    if (string == null || string == '') return '-';
    else
        return General.truncate(string, index, '');
})
Vue.filter('truncate', (string: string, index: number) => {
    if (string == null || string == '') return '-';
    else
        return General.truncate(string, index, '...');
})
Vue.filter('dateStandard', (date: Date) => {
    if (date == undefined) return null;
    return moment(date).format('MM/DD/YYYY');
})
Vue.filter('dateStandardIT', (date: Date) => {
    if (date == undefined) return null;
    return moment(date).format('DD/MM/YYYY');
})

Vue.config.productionTip = true;
let app = new Vue({
    router,
    store,
    i18n,
    mounted() {
        this.$toastr.defaultPosition = 'toast-top-full-width';
        this.$toastr.defaultTimeout = 5000;
    },
    render: h => h(App)
}).$mount('#app');

// Aggiungi questa variabile prima dei router guards per tenere traccia del timeout di loading
let loadingTimeoutId: number | null = null;

router.beforeEach(async (to, from, next) => {
    let currentPath = to.path;
    store.dispatch('setCurrentPath', { currentPath });
    
    // Cancelliamo qualsiasi timeout precedente per evitare conflitti
    if (loadingTimeoutId !== null) {
        clearTimeout(loadingTimeoutId);
        loadingTimeoutId = null;
    }
    
    // Imposta un timeout di 1 secondo prima di mostrare il loading
    loadingTimeoutId = window.setTimeout(() => {
        General.mainLoading(true);
    }, 1000);
    
    if (to.matched.some(record => record.meta.requiresAuth)) {
        let isLogged = await General.IsLogged(app);

        if (!isLogged) {
            next({
                path: '/login',
                query: { from: currentPath }
            })
        } else {
            //Questo non e' piu necessario dato che ho spostato il caricamento della lingua nella created di App.vue
            // await General.loadLanguageFromStoreAsync();
            next()
        }
    } else {
        next()
    }
});

router.afterEach(() => {
    // Cancelliamo il timeout se la navigazione è completata prima di 1 secondo
    if (loadingTimeoutId !== null) {
        clearTimeout(loadingTimeoutId);
        loadingTimeoutId = null;
    }
    
    // Nascondiamo il loading in ogni caso (se è stato attivato)
    General.mainLoading(false);
});